import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { IPluvaAutoCSVideo } from '../PluvaAutoCustomerServicePage';
import { useState } from 'react';
import { YoutubePlayerModal } from '../../../../components/custom/modal/popup/YoutubePlayerModal';

interface VideoCardRowProps {
  video: IPluvaAutoCSVideo;
}

export const VideoCardRow = ({ video }: VideoCardRowProps) => {
  const [isYoutubeModalPopup, setIsYoutubeModalPopup] = useState<boolean>(false);
  const handleVideoClick = () => setIsYoutubeModalPopup(true);
  const handleModalClose = () => setIsYoutubeModalPopup(false);
  return (
    <>
      <VideoCard onClick={handleVideoClick}>
        <VideoThumbnailWrapper>
          <VideoThumbnail thumbnailUrl={video.thumbnailUrl} />
          <GreenChip>
            <IconWrapper>
              <Icon name={'AngleFillRight'} style={{ width: '100%', height: '100%' }} />
            </IconWrapper>
          </GreenChip>
        </VideoThumbnailWrapper>
        <BodySection>
          <VideoTitle>{video.videoTitle}</VideoTitle>
        </BodySection>
      </VideoCard>

      {isYoutubeModalPopup && (
        <YoutubePlayerModal
          isShow={isYoutubeModalPopup}
          youtubeUrl={video.youtubeUrl}
          handleModalClose={handleModalClose}
        />
      )}
    </>
  );
};

const VideoCard = styled.div`
  overflow: hidden;
  display: flex;
  min-width: 200px;
  align-items: flex-start;
  align-self: stretch;

  border-radius: var(--radius-large, 16px);
  cursor: pointer;
`;

const VideoThumbnailWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const VideoThumbnail = styled.div<{ thumbnailUrl: string }>`
  width: 122.772px;
  height: var(--radius-round, 80px);

  background: ${(props) => `url(${props.thumbnailUrl}) lightgray 50% / cover no-repeat`};

  @media (max-width: 768px) {
    width: 92.079px;
    height: 60px;
  }
`;

const BodySection = styled.div`
  display: flex;
  padding: var(--radius-medium, 8px) 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  flex: 1 0 0;
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const VideoTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/XX-Large/xxl-medium */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const GreenChip = styled.div`
  display: flex;
  max-height: 40px;
  padding: var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  position: absolute;
  left: 35px;
  top: 20px;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);

  @media (max-width: 768px) {
    max-height: 22px;
    padding: var(--radius-medium, 8px);

    position: absolute;
    left: 31px;
    top: 19px;
  }
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;

  @media (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
`;
